module.exports = __webpack_public_path__ + "static/img/enterprise-big-2.b9a4ba12.png";